import { api, PAGE_SIZE, urlUtils } from '@igblsln/store';
const API_PATH = "/construction/receipt/";
export const constructionReceiptApi = api.injectEndpoints({
    overrideExisting: false,
    endpoints: (build) => ({
        getSourceOfFunds: build.query({
            query: () => {
                return {
                    url: urlUtils("/sale/source_of_fund/?without_pagination=1"),
                };
            },
        }),
        listReceiveConstructionInvoice: build.query({
            query: ({ page, size, project, unit }) => {
                return {
                    url: urlUtils("/construction/payment/all?receivable_invoices=1", `&page=${page || 1}&page_size=${size || PAGE_SIZE}${project ? `&project_id=${project}` : ''}${unit ? `&unit_id=${unit}` : ''}`),
                };
            },
            providesTags: (result) => {
                var _a;
                return result ? [
                    ...(_a = result === null || result === void 0 ? void 0 : result.results) === null || _a === void 0 ? void 0 : _a.map(({ key }) => ({ type: "RECEIVE_CONSTRUCTION_INVOICE", key })),
                    { type: "RECEIVE_CONSTRUCTION_INVOICE", id: 'LIST' },
                ] : [{ type: "RECEIVE_CONSTRUCTION_INVOICE", id: 'LIST' }];
            },
        }),
        listConstructionReceipt: build.query({
            query: ({ page, size, project, unit }) => {
                return {
                    url: urlUtils(API_PATH, `?page=${page || 1}&page_size=${size || PAGE_SIZE}${project ? `&project_id=${project}` : ''}${unit ? `&unit_id=${unit}` : ''}`),
                };
            },
            providesTags: (result) => {
                var _a;
                return result ? [
                    ...(_a = result === null || result === void 0 ? void 0 : result.results) === null || _a === void 0 ? void 0 : _a.map(({ key }) => ({ type: "RECEIVE_CONSTRUCTION_INVOICE", key })),
                    { type: "RECEIVE_CONSTRUCTION_INVOICE", id: 'LIST' },
                ] : [{ type: "RECEIVE_CONSTRUCTION_INVOICE", id: 'LIST' }];
            },
        }),
        addReceiveConstructionInvoice: build.mutation({
            query: (body) => ({
                url: API_PATH,
                method: 'POST',
                body,
            }),
            invalidatesTags: [{ type: "RECEIVE_CONSTRUCTION_INVOICE", id: 'LIST' }],
        }),
        deleteConstructionReceipt: build.mutation({
            query(id) {
                return {
                    url: `${API_PATH}${id}`,
                    method: 'DELETE',
                };
            },
            invalidatesTags: (payment) => [{ type: "RECEIVE_CONSTRUCTION_INVOICE", id: payment === null || payment === void 0 ? void 0 : payment.id }],
        }),
        getErrorProne: build.query({
            query: () => 'error-prone',
        }),
        exportConstructionReceipts: build.query({
            query: ({ projectId, unitId }) => {
                const unitParam = unitId ? `&unit_id=${unitId}` : "";
                return {
                    url: urlUtils(`/construction/receipt/export?project_id=${projectId}${unitParam}`),
                };
            },
        }),
    }),
});
export const { useGetSourceOfFundsQuery, useListReceiveConstructionInvoiceQuery, useListConstructionReceiptQuery, useAddReceiveConstructionInvoiceMutation, useDeleteConstructionReceiptMutation, useGetErrorProneQuery, useExportConstructionReceiptsQuery, } = constructionReceiptApi;
